import { PRIORITY_ORDER as ORDER, PRIORITY_SEGMENT as SEGMENT } from "../data/priorityColors";
import type { Priority } from "../data/types";

/**
 * Stacked open-request bar for one person.
 *
 * Segment widths are shares of the busiest person's total, not of this
 * person's own total — otherwise everyone's bar fills the track and the
 * comparison the panel exists for disappears.
 */
export function LoadBar({ counts, scale }: { counts: Record<Priority, number>; scale: number }) {
  const denominator = scale > 0 ? scale : 1;

  return (
    <span className="flex h-1.5 overflow-hidden rounded-full bg-gray-200">
      {ORDER.map((p) =>
        counts[p] > 0 ? (
          <i key={p} className={`block h-full ${SEGMENT[p]}`} style={{ width: `${(counts[p] / denominator) * 100}%` }} />
        ) : null,
      )}
    </span>
  );
}

export function LoadLegend() {
  return (
    <div className="flex gap-4 text-xs text-[var(--text-2)]">
      {ORDER.map((p) => (
        <span key={p} className="inline-flex items-center gap-1.5">
          <i className={`inline-block h-2 w-2 rounded-full ${SEGMENT[p]}`} />P{p}
        </span>
      ))}
      <span className="ml-auto">Weighted by priority</span>
    </div>
  );
}
